import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Studio from "@/pages/Studio";
import Login from "@/pages/Login";
import Channels from "@/pages/Channels";
import Dashboard from "@/pages/Dashboard";
import Niches from "@/pages/Niches";
import Regenerate from "@/pages/Regenerate";
import FunnyAnimals from "@/pages/FunnyAnimals";
import DeployStamp from "@/components/DeployStamp";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="grain min-h-screen flex items-center justify-center bg-[#0b0c10]" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin text-[#00e5ff]" />
      </div>
    );
  }
  if (!user && !location.state?.user) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback FIRST, before any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/niches" element={<ProtectedRoute><Niches /></ProtectedRoute>} />
      <Route path="/regenerate" element={<ProtectedRoute><Regenerate /></ProtectedRoute>} />
      <Route path="/funny-animals" element={<ProtectedRoute><FunnyAnimals /></ProtectedRoute>} />
      <Route path="/channels" element={<ProtectedRoute><Channels /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <DeployStamp />
          <Toaster position="bottom-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
